import createReactComponent from '../createReactComponent';
export default createReactComponent('pause-circle', 'PauseCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M10 9v6m4-6v6","key":"svg-0"}]]);